"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupSurcharges = exports.arrayToObject = void 0;
exports.parseDeliveryAddress = parseDeliveryAddress;
exports.toCamelCaseString = exports.removeDuplicates = void 0;
var _lodash = require("lodash");
const removeDuplicates = array => [...new Set(array)];
exports.removeDuplicates = removeDuplicates;
const toCamelCaseString = value => {
  if (!(0, _lodash.isString)(value)) {
    return value;
  }
  return value.replace(/-([a-z])/g, match => match[1].toUpperCase());
};

/* Parse delivery address and generate a legible label for displays. */
exports.toCamelCaseString = toCamelCaseString;
function parseDeliveryAddress(deliveryAddress, countryName, countryCodeAlpha3) {
  if (!deliveryAddress) {
    return null;
  }
  const address = deliveryAddress.address.replace(", ".concat(countryName, ", ").concat(countryCodeAlpha3), "");
  const deliveryAddressData = {
    address,
    postcode: deliveryAddress.postcode,
    floorUnit: deliveryAddress.floorUnit,
    buildingName: deliveryAddress.building,
    deliveryInstructions: deliveryAddress.deliveryInstructions,
    streetName: deliveryAddress.streetName
  };
  return {
    ...deliveryAddressData,
    name: (0, _lodash.without)([deliveryAddressData.floorUnit, deliveryAddressData.buildingName], null, undefined).join(", "),
    label: (0, _lodash.without)([deliveryAddressData.floorUnit, (0, _lodash.without)([deliveryAddressData.buildingName, deliveryAddressData.streetName, deliveryAddressData.postcode], null, undefined).join(", ")], null, undefined, "").join(", ")
  };
}

/* Group surcharges based on surchargeType */
const groupSurcharges = surcharges => (0, _lodash.chain)(surcharges).groupBy("surchargeType").mapKeys((value, key) => toCamelCaseString(key)).value();
exports.groupSurcharges = groupSurcharges;
const arrayToObject = array => {
  let newObj = {};
  array.forEach(newElem => {
    newObj = {
      ...newObj,
      ...newElem
    };
  });
  return newObj;
};
exports.arrayToObject = arrayToObject;